import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { UsersListModel, UsersStore } from "../../views/users/domain/users.model";
import {convertToForm} from "@slices/report-details.slice";



export const fetchOperators =
    createAsyncThunk<any[], void>("operators/fetchOperators",
        async () => {
            const url = `${AppConstants.api}/operators`
            const response = await api.get<any[]>(url)
            return response.data?.map(data=>{
                return {
                    ...data,
                    fullName: `${ data.firstName} ${data.lastName ? data.lastName : ''}`
                }
            })
        })

export const createOperator = createAsyncThunk(
    "operators/createOperator",
    async (operatorData: { firstName: string, lastName: string, designation: string, signAndStamp: string | null }, { rejectWithValue }) => {
        try {
            const formData = convertToForm(operatorData, Object.keys(operatorData));
        console.log("Operator data in api slice",operatorData)

            const response = await api.post<ApplicationResponse<UsersListModel>>(
                `${AppConstants.api}/operators`,
               formData,
            );
            return response.data.data;
        } catch (err) {
            console.error("Create Operator Error:", err);
            return rejectWithValue("Failed to create operator");
        }
    }
);

// UPDATE
export const updateOperator = createAsyncThunk(
    "operators/updateOperator",
    async (
        { id, operatorData }: { id: string; operatorData: {id: string, firstName: string, lastName: string, designation: string, signAndStamp: string | null } },
        { rejectWithValue }
    ) => {
        try {
            const formData = convertToForm(operatorData, Object.keys(operatorData));

            const response = await api.put<ApplicationResponse<UsersListModel>>(
                `${AppConstants.api}/operators/${id}`,
                formData
            );
            return response.data.data;
        } catch (err) {
            console.error("Update Operator Error:", err);
            return rejectWithValue("Failed to update operator");
        }
    }
);

export const deleteOperator = createAsyncThunk(
    "operators/deleteOperator",
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await api.delete<ApplicationResponse<any[]>>(
                `${AppConstants.api}/operators/${id}`
            );
            return response.data.data || [];
        } catch (err) {
            console.error("Delete Operator Error:", err);
            return rejectWithValue("Failed to delete operator");
        }
    }
);

const initialState: UsersStore = {
    minimal: { status: "idle", error: null, data: [] },
};

const operatorsSlice = createSlice({
    name: "operators",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchOperators.pending, (state) => {
                state.minimal.status = "loading";
                state.minimal.data = [];
                state.minimal.error = null;
            })
            .addCase(fetchOperators.fulfilled, (state, action) => {
                state.minimal.status = "idle";
                state.minimal.data = action.payload ?? [];
                state.minimal.error = null;
            })
            .addCase(fetchOperators.rejected, (state, action) => {
                state.minimal.status = "failed";
                state.minimal.data = [];
                state.minimal.error = action.payload as string;
            })
            .addCase(deleteOperator.fulfilled, (state, action) => {
                state.minimal.data = state.minimal.data.filter(
                    (user) => user.id !== action.meta.arg
                );
            });

    },
});

export default operatorsSlice.reducer;
